import { AxiosObjwithOutJWT } from '../configuration/axios-setup';

class appointmentServices {
  getAvailableSlots(accountId, startTime, endTime) {
    return AxiosObjwithOutJWT
      .get(`/api/healthapp/slot/view/${accountId}/${startTime}/${endTime}`)
  }
  getPricingForCoach(accountId) {
    return AxiosObjwithOutJWT
      .get(`/api/healthapp/slot/${accountId}/get-slot-pricing`)
  }
  generateRazorPayOrderId(resObj) {
    return AxiosObjwithOutJWT
      .post(`/api/healthapp/slot/get-razorpay-order-id`, resObj, {
        'accept': 'application/json'
      })
  }
  bookSlot(resObj) {
    return AxiosObjwithOutJWT
      .post(`/api/healthapp/slot/book`, resObj, {
        'accept': 'application/json'
      })
  }
  getUnavailableDatesForCoach(accountId) {
    return AxiosObjwithOutJWT
      .get(`/api/healthapp/slot/view/${accountId}/availability/status/unavailable`)
  }
}

const AppointmentServices = new appointmentServices();
export default AppointmentServices;